import { useState } from "react";
import { deleteDepartamento, getDepartamentosPanel } from "../../services/DepartamentosServices";
import { DepartamentosContext } from "./DepartamentosContext"

export const DepartamentosState = ({ children }) => {

    const getDepartamentosPanelData = async (searchTerm, searchIDFilter, numPagina, filas) => {
        let res = await getDepartamentosPanel(searchTerm, searchIDFilter, numPagina, filas)
        return res
    }

    const deleteDepartamentoData = async (body) => {
        const res = await deleteDepartamento(body)
        if (res) getDepartamentosPanelData()
        return res
    }


    return <DepartamentosContext.Provider value={{
        deleteDepartamentoData,
        getDepartamentosPanelData,
    }} >
        {children}
    </DepartamentosContext.Provider>
}